import {
  ATTRIBUTION_FIELDS,
  type AttributionPayload,
  sanitizeAttributionValue,
} from '@/utils/attribution';

function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
  if (!match?.[1]) return undefined;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}

/**
 * Read attribution from GTM hidden inputs (FormData) with cookie fallback.
 * Form values win over cookies when both are present.
 */
export function getAttributionPayload(
  form?: HTMLFormElement | null
): AttributionPayload {
  const fromCookies: AttributionPayload = {};
  for (const key of ATTRIBUTION_FIELDS) {
    const value = sanitizeAttributionValue(readCookie(key));
    if (value) fromCookies[key] = value;
  }

  if (!form) return fromCookies;

  const formData = new FormData(form);
  const fromForm: AttributionPayload = {};
  for (const key of ATTRIBUTION_FIELDS) {
    const value = sanitizeAttributionValue(formData.get(key));
    if (value) fromForm[key] = value;
  }

  return { ...fromCookies, ...fromForm };
}
